export const ANIMATE = {
  init: function () {
    const targets = document.querySelectorAll('.js-animate')

    if (targets.length > 0) {
      // 画面幅に応じた rootMargin の設定
      const rootMarginValue = window.innerWidth > 768 ? '0px 0px -20% 0px' : '0px 0px -15% 0px'

      // Intersection Observer の作成
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-shown')
            }
          })
        },
        {
          rootMargin: rootMarginValue,
          threshold: 0, // 0に設定して一部が見えたタイミングで発火
        },
      )

      // 各ターゲットを監視
      targets.forEach(target => observer.observe(target))
    }

    const circle = document.querySelector('.js-circle')

    if (circle) {
      const windowHeight = window.innerHeight * 0.8

      window.addEventListener('scroll', () => {
        const rect = circle.getBoundingClientRect() // 要素の位置を取得
        const elementTop = rect.top // 要素の上端位置
        const currentScrollY = window.scrollY // 現在のスクロール位置

        // ページ上部に到達した場合、元のサイズにリセット
        if (currentScrollY === 0) {
          circle.style.transform = 'translateX(-50%) scale(1)'
          return // 処理を終了
        }

        // 通常のスクロール処理
        if (elementTop < windowHeight && elementTop > 0) {
          const progress = 1 - elementTop / windowHeight // スクロール進捗を計算 (0 ~ 1)
          const scale = 1 + progress * 0.4 // スケール計算 (1倍から2倍)

          // 中央配置を維持するtransformを設定
          circle.style.transform = `translateX(-50%) scale(${scale})`
        }
      })
    }
  },
}
